import querystring from 'querystring';
import reqwest from 'reqwest';
import lodash from 'lodash';
import { getAppConfig, getClientData } from 'common/util/configUtil';
import { queryGraphQL } from 'common/util/query';
import { toQuery, node } from 'common/util/queryHelper';
import { openPopup } from 'common/util/popup';
import { addApplicationMessage } from 'common/actions/applicationMessagesActions';
import { saveAuthCredentials } from 'common/util/auth-storage';
import url from 'url';

export const LOGIN_START = 'LOGIN_START';
export const LOGIN_COMPLETE = 'LOGIN_COMPLETE';
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const LOGIN_EMAIL_ERROR = 'LOGIN_EMAIL_ERROR';
export const CLEAR_LOGIN_STATUS = 'CLEAR_LOGIN_STATUS';
export const SHOW_PASSWORD = 'SHOW_PASSWORD';
export const SHOW_EXPIRED_PASSWORD = 'SHOW_EXPIRED_PASSWORD';

export const RESET_PASSWORD_ANSWER_ERROR = 'RESET_PASSWORD_ANSWER_ERROR';
export const RESET_PASSWORD_VALIDATION_ERROR = 'RESET_PASSWORD_VALIDATION_ERROR';

export const KEYMASTER_SIGNING_ERROR = 'KEYMASTER_SIGNING_ERROR';

export const SHOW_PASSWORD_RESET_EMAIL_SENT_SCREEN = 'SHOW_PASSWORD_RESET_EMAIL_SENT_SCREEN';
export const GET_ME_START = 'GET_ME_START';
export const GET_ME_COMPLETE = 'GET_ME_COMPLETE';
export const GET_ME_ERROR = 'GET_ME_ERROR';
export const UPDATE_ME = 'UPDATE_ME';
export const REMOVE_ME = 'REMOVE_ME';
export const SET_RELOADING = 'SET_RELOADING';
export const LOGIN_SET_SESSION = 'LOGIN_SET_SESSION';

const AUTH_ERROR_MESSAGE = 'Authentication failed. If the problem persists, contact your administrator.';

function getLocationParams(location) {
    const rawQueryString = location.search || '';
    const qs = rawQueryString.replace('?', '');
    const queryStringObject = querystring.parse(qs);

    return queryStringObject;
}

export function listenForCredentials(popup, resolve, reject) {
    if (!resolve) {
        return new Promise((resolve, reject) => {
            listenForCredentials(popup, resolve, reject);
        });
    } else {
        let creds;

        try {
            creds = getLocationParams(popup.location);
        }
        catch (e) {
            // do nothing
        }

        if (creds && creds.token && creds.sub) {
            popup.close();
            const auth = { accessToken: creds.token, sub: creds.sub, pdftronLicense: window.btoa(creds.pdftron) };
            saveAuthCredentials(auth);
            resolve(auth);
        }
        else if (popup.closed) {
            reject({ errors: AUTH_ERROR_MESSAGE });
        }
        else {
            setTimeout(() => {
                listenForCredentials(popup, resolve, reject);
            }, 100);
        }
    }
}

function authenticate(url) {
    const popup = openPopup(url, 'login');
    return listenForCredentials(popup);
}

export function loginStart() {
    return { type: LOGIN_START };
}

export function loginError(errors) {
    return { type: LOGIN_ERROR, errors };
}

export function loginEmailError(errors) {
    return { type: LOGIN_EMAIL_ERROR, errors };
}

export function loginShowPassowrd(payload) {
    return { type: SHOW_PASSWORD, payload };
}

export function loginShowExpiredPassword(payload) {
    return { type: SHOW_EXPIRED_PASSWORD, payload };
}

export function passwordResetEmailSent(payload) {
    return { type: SHOW_PASSWORD_RESET_EMAIL_SENT_SCREEN, payload };
}

export function loginSetSessionId(payload) {
    return { type: LOGIN_SET_SESSION, payload };
}

export function loginComplete(auth) {
    return { type: LOGIN_COMPLETE, payload: auth };
}

export function clearLoginStatus() {
    return { type: CLEAR_LOGIN_STATUS };
}

//reset password actions
export function resetPasswordAnswerError(errors) {
    return { type: RESET_PASSWORD_ANSWER_ERROR, errors };
}

export function resetPasswordValidationError(errors) {
    return { type: RESET_PASSWORD_VALIDATION_ERROR, errors };
}

export function keymasterSigningError(errors) {
    return { type: KEYMASTER_SIGNING_ERROR, errors };
}

export function getMeStart() {
    return { type: GET_ME_START };
}
export function getMeError(errors) {
    return { type: GET_ME_ERROR, errors };
}
export function getMeComplete(me) {
    return { type: GET_ME_COMPLETE, payload: me };
}

export function getMeQuery() {
    const query = toQuery(node('me', [
        'id',
        'sub',
        'name',
        'firstName',
        'lastName',
        'email',
        'systemPermissions',
        'institutionPermissions',
        'binderPermissions',
        'canManageIntegrationStatuses',
        node('binderTemplates', [
            'id',
            'displayName',
            'billable'
        ]),
        node('groups', [
            'displayName'
        ]),
        node('featureAccess', [
            'entityKey',
            node('features', [
                'featureKey',
                'subscribed'
            ]),
        ]),
        node('monitorFeatureAccess', [
            'entityKey',
            node('features', [
                'featureKey',
                'subscribed'
            ]),
        ]),
        node('monitorInstitutions', [
            'id',
            'displayName'
        ]),
        'hasCompletedRegistration',
        'lastLogin',
        'institutionTimezone',
        'defaultTimezone',
        'isInstitutionCentralized',
        node('documentTypes', [
            'id',
            'name',
            'displayName',
            'isActive',
            'permissions',
            'autonameTemplate',
        ]),
        node('institution', [
            'id',
            'name',
        ]),
        node('institutions', [
            'id',
            'displayName',
            'status',
            'notes',
            node('institutionLink', [
                'status',
                'isDefaultInstitution',
            ])
        ]),
        'isSso',
        'userPinnedBinders',
    ]));

    return queryGraphQL(query);
}

function getMeOnLoginQuery() {
    const query = toQuery(node('me', [
        'id',
        'sub',
        'name',
        'firstName',
        'lastName',
        'email',
        'systemPermissions',
        'institutionPermissions',
        'binderPermissions',
        'canManageIntegrationStatuses',
        node('binderTemplates', [
            'id',
            'displayName',
            'billable'
        ]),
        node('groups', [
            'displayName'
        ]),
        node('featureAccess', [
            'entityKey',
            node('features', [
                'featureKey',
                'subscribed'
            ]),
        ]),
        node('monitorInstitutions', [
            'id',
            'displayName'
        ]),
        node('monitorFeatureAccess', [
            'entityKey',
            node('features', [
                'featureKey',
                'subscribed'
            ]),
        ]),
        'hasCompletedRegistration',
        'lastLogin',
        'isSso',
        'logoutLandingPage',
        'institutionTimezone',
        'defaultTimezone',
        'isInstitutionCentralized',
        node('documentTypes', [
            'id',
            'name',
            'displayName',
            'isActive',
            'permissions',
            'autonameTemplate',
        ]),
        node('institution', [
            'id',
            'name',
            node('properties', [
                'type',
                'value',
            ]),
        ]),
        node('institutions', [
            'id',
            'displayName',
            'status',
            'notes',
        ]),
        'userPinnedBinders',
    ]));

    return queryGraphQL(query);
}

export function getMeOnLogin() {
    return dispatch => {
        dispatch(getMeStart());
        return getMeOnLoginQuery().catch(xhr => {
            return null;
        }).then(me => {
            dispatch(getMeComplete(me));
        }).catch((errors) => dispatch(getMeError(errors)));
    };
}

export function login(entryQueryParameters = {}) {
    return (dispatch, getState) => {
        dispatch(loginStart());

        const rawLoginUrl = lodash.get(getState(), 'application.config.loginUrl', null);
        if (lodash.isNil(rawLoginUrl)) {
            return dispatch(loginError('Application Configuration not found'));
        }
        const loginUrl = url.parse(rawLoginUrl);
        if (!lodash.isEmpty(entryQueryParameters)) {
            loginUrl.query = entryQueryParameters;
        }

        return authenticate(loginUrl.format())
            .then(auth => dispatch(loginComplete(auth)))
            .catch((errors) => dispatch(loginError(errors)))
            .then(() => dispatch(getMeStart()))
            .then(() => getMeOnLoginQuery())
            .then(me => dispatch(getMeComplete(me)))
            .catch((errors) => dispatch(getMeError(errors)));
    };
}

export function showPasswordInput(state) {
    return async (dispatch, getState) => {
        dispatch(loginShowPassowrd(state));
    };
}

export function setLoginEmailError(error) {
    return async (dispatch, getState) => {
        dispatch(loginEmailError(error));
    };
}

export function setResetPasswordAnswerError(error) {
    return async (dispatch, getState) => {
        dispatch(resetPasswordAnswerError(error));
    };
}

export function setKeymasterSigningError(error) {
    return async (dispatch, getState) => {
        dispatch(keymasterSigningError(error));
    };
}
export function setResetPasswordValidationError(error) {
    return async (dispatch, getState) => {
        dispatch(resetPasswordValidationError(error));
    };
}

export function setPasswordResetEmailSent(state) {
    return async (dispatch, getState) => {
        dispatch(passwordResetEmailSent(state));
    };
}

export function forgotPasswordV4(emailID) {
    return async (dispatch, getState) => {
        try {
            const clientData = await getClientData();
            const authorizeData = await getAuthorize(clientData);
            if (authorizeData && authorizeData.status) {
                const sessionId = authorizeData.sessionId;
                dispatch(loginSetSessionId(sessionId));
                const loginResult = await loginWithPassword({ email: emailID, sessionId }, true);
                if (loginResult.status) {
                    if (loginResult.isSSO && loginResult.redirectURL) {
                        return dispatch(loginEmailError('This account\'s password can only be managed through your organization\'s Single Sign On provider.'));
                    }
                    await sentForgotPasswordEmailReset(emailID, sessionId);
                }
                dispatch(passwordResetEmailSent(true));
            } else {
                dispatch(addApplicationMessage('Error', 'Authorize failed while sending reset password email.'));
            }
        }
        catch (err) {
            dispatch(passwordResetEmailSent(false));
            dispatch(addApplicationMessage('Error', 'Password Reset Email Not Sent.'));
        }
    };
}

export function expiredPassword(expiredData) {
    return async (dispatch, getState) => {
        const loginSessionId = lodash.get(getState(), 'loginSessionId', null);

        dispatch(loginSetSessionId(loginSessionId));
        const urlBodyData = new URLSearchParams();

        urlBodyData.append('sessionId', loginSessionId);
        urlBodyData.append('email', expiredData.email.toLowerCase());
        urlBodyData.append('oldPassword', expiredData.currentPassword);
        urlBodyData.append('newPassword', expiredData.newPassword);
        urlBodyData.append('confirmPassword', expiredData.newPassword);
        urlBodyData.append('api', 'true');
        const path = 'changepassword';
        const loginResult = await authRequest({ path, body: urlBodyData.toString(), method: 'POST' });
        if (loginResult.status) {
            dispatch(loginShowExpiredPassword(false));
            const creds = await getTokenData(loginResult.redirectPath);
            if (creds && creds.token && creds.sub) {
                const auth = { accessToken: creds.token, sub: creds.sub, pdftronLicense: window.btoa(creds.pdftron) };
                await saveAuthCredentials(auth);
                await dispatch(loginComplete(auth));
                await dispatch(getMeStart());
                const me = await getMeOnLoginQuery();
                await dispatch(getMeComplete(me));
                window.location.href = '/';
            }
            else {
                window.location.href = '/?expiredSession=true';
            }
        }
        else {
            return loginResult;
        }
    };
}


export function ssoSettingPin(loginData) {
    return async (dispatch, getState) => {
        dispatch(loginStart());
        try {
            const urlBodyData = new URLSearchParams();
            urlBodyData.append('pin', loginData.password);
            urlBodyData.append('email', loginData.email.toLowerCase());
            urlBodyData.append('api', 'true');

            const loginResult = await authRequest({ path: 'pin', body: urlBodyData.toString(), method: 'POST' });
            if (loginResult && loginResult.status) {
                const creds = await getTokenData(loginResult.redirectPath);
                if (creds && creds.token && creds.sub) {
                    const auth = { accessToken: creds.token, sub: creds.sub, pdftronLicense: window.btoa(creds.pdftron) };
                    await saveAuthCredentials(auth);
                    await dispatch(loginComplete(auth));
                    await dispatch(getMeStart());
                    const me = await getMeOnLoginQuery();
                    await dispatch(getMeComplete(me));
                }
                else {
                    window.location.href = '/?expiredSession=true';
                }
            }
            else {
                window.location.href = '/?expiredSession=true';
            }
        }
        catch (e) {
            dispatch(loginError(e));
            window.location.href = '/?expiredSession=true';
        }
    };
}

export async function sentForgotPasswordEmailReset(emailID, sessionID) {
    const urlBodyData = new URLSearchParams();
    urlBodyData.append('sessionId', sessionID);
    urlBodyData.append('email', emailID.toLowerCase());
    urlBodyData.append('api', true);

    const path = 'forgotpassword';
    await authRequest({ path, body: urlBodyData.toString(), method: 'POST' });
}

export async function verifyState(state) {
    try {
        const response = await fetch('/verify/state', {
            method: 'POST',
            body: JSON.stringify({ state }),
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (response.ok) {
            return await response.json();
        } else {
            throw new Error(await response.text());
        }
    } catch (error) {
        throw new Error(error.message);
    }
}
export function loginV4(loginData, isWithEmail, onSessionExpired) {
    return async (dispatch, getState) => {
        dispatch(loginStart());
        try {
            const clientData = await getClientData();
            const authorizeData = await getAuthorize(clientData);
            if (authorizeData && authorizeData.status) {
                const sessionId = authorizeData.sessionId;
                dispatch(loginSetSessionId(sessionId));
                const loginResult = await loginWithPassword({ ...loginData, sessionId }, isWithEmail);
                if (loginResult && loginResult.status) {
                    if (loginResult.redirectURL && loginResult.isSSO) {
                        window.location.href = loginResult.redirectURL;
                    }
                    else if (isWithEmail)
                        dispatch(loginShowPassowrd(true));
                    if (!isWithEmail) {
                        const creds = await getTokenData(loginResult.redirectPath);
                        if (creds && creds.token && creds.sub) {
                            const auth = { accessToken: creds.token, sub: creds.sub, pdftronLicense: window.btoa(creds.pdftron) };
                            await saveAuthCredentials(auth);
                            await dispatch(loginComplete(auth));
                            await dispatch(getMeStart());
                            const me = await getMeOnLoginQuery();
                            await dispatch(getMeComplete(me));
                        }
                        else {
                            onSessionExpired();
                        }
                    }
                }
                else {
                    if (isWithEmail) {
                        dispatch(loginShowPassowrd(true));
                        if (loginResult.isSSO)
                            dispatch(loginError(loginResult.error));
                    }
                    else {
                        if (loginResult.changePassword) {
                            dispatch(loginShowExpiredPassword(true));
                        }
                        else
                            dispatch(loginError(loginResult.error));
                    }
                }

            }

        }
        catch (e) {
            if (isWithEmail)
                dispatch(loginShowPassowrd(true));
            else {
                if (e === 'session timeout') {
                    onSessionExpired();
                }
                else {
                    dispatch(loginError(e));
                }
            }
        }
    };
}

export function onChallengeQuestionAnswer(answer, challengeQuestionAnswerParams) {
    return async (dispatch) => {
        const urlBodyData = new URLSearchParams();
        urlBodyData.append('nonce', challengeQuestionAnswerParams.nonce);
        urlBodyData.append('email', challengeQuestionAnswerParams.email.toLowerCase());
        urlBodyData.append('questionId', challengeQuestionAnswerParams.questionId);
        urlBodyData.append('from', 'challengeQuestion');
        urlBodyData.append('passwordResetId', challengeQuestionAnswerParams.passwordResetId);
        urlBodyData.append('answer', answer);
        urlBodyData.append('api', 'true');
        const path = 'resetPassword';
        return authRequest({ path, body: urlBodyData.toString(), method: 'POST' })
            .catch(e => {
                dispatch(resetPasswordAnswerError(e.message));
            });
    };
}

export function changePassword(changePasswordParams) {
    return async (dispatch) => {
        try {
            const urlBodyData = new URLSearchParams();
            urlBodyData.append('email', changePasswordParams.email.toLowerCase());
            urlBodyData.append('sessionId', changePasswordParams.sessionId);
            urlBodyData.append('oldPassword', changePasswordParams.oldPassword);
            urlBodyData.append('newPassword', changePasswordParams.newPassword);
            urlBodyData.append('confirmPassword', changePasswordParams.confirmPassword);
            urlBodyData.append('api', 'true');
            const path = 'changePassword';
            const changePasswordResponse = await authRequest({ path, body: urlBodyData.toString(), method: 'POST' });
            if (changePasswordResponse.code) {
                dispatch(addApplicationMessage('Success', 'Password Changed Successfully.'));
            }
            return changePasswordResponse;
        }
        catch (e) {
            dispatch(resetPasswordAnswerError(e.message));
        }
    };
}
export function setChallengeQuestionAnswer(challengeQuestionAnswerParams) {
    return async (dispatch) => {
        try {
            const urlBodyData = new URLSearchParams();
            urlBodyData.append('nonce', challengeQuestionAnswerParams.nonce);
            urlBodyData.append('email', challengeQuestionAnswerParams.email.toLowerCase());
            urlBodyData.append('sessionId', challengeQuestionAnswerParams.sessionId);
            urlBodyData.append('challengeQuestionId', challengeQuestionAnswerParams.challengeQuestionId);
            urlBodyData.append('challengeQuestionAnswer', challengeQuestionAnswerParams.challengeQuestionAnswer);
            urlBodyData.append('api', 'true');
            const path = 'setChallengeQuestion';
            return await authRequest({ path, body: urlBodyData.toString(), method: 'POST' });
        }
        catch (e) {
            dispatch(resetPasswordAnswerError(e.message));
        }
    };
}

export function setRegistrationPassword(registrationPasswordParams) {
    return async (dispatch) => {
        try {
            const { nonce, email, sessionId, password } = registrationPasswordParams;
            dispatch(emailClicked(nonce, email));

            const urlBodyData = new URLSearchParams();
            urlBodyData.append('nonce', nonce);
            urlBodyData.append('email', email.toLowerCase());
            urlBodyData.append('sessionId', sessionId);
            urlBodyData.append('newPassword', password);
            urlBodyData.append('confirmPassword', password);
            urlBodyData.append('api', 'true');
            const path = 'setPassword';
            const passwordSetResponse = await authRequest({ path, body: urlBodyData.toString(), method: 'POST' });
            if (passwordSetResponse && passwordSetResponse.status) {
                const creds = await getTokenData(passwordSetResponse.redirectPath);
                if (creds && creds.token && creds.sub) {
                    const auth = { accessToken: creds.token, sub: creds.sub, pdftronLicense: window.btoa(creds.pdftron) };
                    await saveAuthCredentials(auth);
                    await dispatch(loginComplete(auth));
                    await dispatch(getMeStart());
                    await dispatch(passwordHasBeenSet());
                    const me = await getMeQuery();
                    await dispatch(getMeComplete(me));
                }
            }
            if (passwordSetResponse.error)
                if (passwordSetResponse.error && passwordSetResponse.error.startsWith('Validation error: ')) {
                    passwordSetResponse.error = passwordSetResponse.error.replace('Validation error: ', '');
                }
            dispatch(resetPasswordValidationError(passwordSetResponse.error));
        }
        catch (e) {
            dispatch(resetPasswordValidationError(e));
        }
    };
}

export const fetchRegisterData = async (nonce, email) => {
    const registerUrl = `/register?nonce=${encodeURIComponent(nonce)}&email=${encodeURIComponent(email)}`;
    try {
        const response = await fetch(registerUrl, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (response.ok) {
            return await response.json();
        } else {
            throw new Error(await response.text());
        }
    } catch (error) {
        throw new Error(error.message);
    }
};

export const getRegistrationDetails = async (url) => {
    try {
        const response = await authRequest({ path: url, method: 'GET' });
        return response;
    } catch (error) {
        throw new Error(error.message);
    }
};

export const getallChallengeQuestions = async (url) => {
    try {
        const response = await authRequest({ path: url, method: 'GET' });
        return response;
    } catch (error) {
        throw new Error(error.message);
    }
};

export const fetchSignUrl = async (accessToken, sso = false, originUrl = '') => {
    let signInUrl = `${originUrl}/sign?access_token=${accessToken}&api=true`;
    if (sso) {
        signInUrl += '&ssosign=true';
    }
    try {
        const response = await fetch(signInUrl, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (response.ok) {
            return await response.json();
        } else {
            throw new Error(await response.text());
        }
    } catch (error) {
        throw new Error(error.message);
    }
};

export const fetchChangePasswordUrl = async (accessToken) => {
    const changePasswordUrl = `/changePassword?access_token=${accessToken}&api=true`;
    try {
        const response = await fetch(changePasswordUrl, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (response.ok) {
            return await response.json();
        } else {
            throw new Error(await response.text());
        }
    } catch (error) {
        throw new Error(error.message);
    }
};


export const getSigningDetails = async (url) => {
    try {
        const response = await authRequest({ path: url, method: 'GET' });
        return response;
    } catch (error) {
        throw new Error(error.message);
    }
};

export const getChangePasswordDetails = async (url) => {
    try {
        const response = await authRequest({ path: url, method: 'GET' });
        return response;
    } catch (error) {
        throw new Error(error.message);
    }
};

export function keymasterSign(signingParams) {
    return async (dispatch) => {

        try {
            const urlBodyData = new URLSearchParams();
            urlBodyData.append('email', signingParams.email.toLowerCase());
            urlBodyData.append('password', signingParams.password);
            urlBodyData.append('api', true);
            const path = `sign/${signingParams.sessionId}`;
            return await authRequest({ path, body: urlBodyData.toString(), method: 'POST' });
        }
        catch (e) {
            dispatch(keymasterSigningError(e.error || 'Something went wrong'));
        }
    };
}

export function onResetPassword(password, resetPasswordParams) {
    return async (dispatch) => {

        try {
            const urlBodyData = new URLSearchParams();
            urlBodyData.append('nonce', resetPasswordParams.nonce);
            urlBodyData.append('email', resetPasswordParams.email.toLowerCase());
            urlBodyData.append('questionId', resetPasswordParams.questionId);
            urlBodyData.append('from', 'changePassword');
            urlBodyData.append('passwordResetId', resetPasswordParams.passwordResetId);
            urlBodyData.append('newPassword', password);
            urlBodyData.append('confirmPassword', password);
            urlBodyData.append('state', resetPasswordParams.state);
            urlBodyData.append('api', 'true');
            const path = 'resetPassword';
            return await authRequest({ path, body: urlBodyData.toString(), method: 'POST' });
        }
        catch (e) {
            dispatch(resetPasswordValidationError(e.message));
        }
    };
}

export function getAuthorize(clientData) {
    const path = `authorizeV4?client_id=${clientData.client_id}&redirect_uri=${clientData.redirect_uri}&response_type=code&scope=${clientData.scope}&state=${clientData.state}&sub=&loginMethodId=`;
    return authRequest({ path, method: 'GET' });

}
export async function getTokenData(urlData) {
    const response = await fetch(urlData + '&appredirect=true', {
        method: 'GET',
        credentials: 'include',
    });
    if (response.status === 401) {
        return 'sessionTimeout';
    }
    if (response.status !== 500) {
        const result = await response.json();
        return result;
    }

}

export async function loginWithPassword(loginData, isWithEmail = false) {
    const urlBodyData = new URLSearchParams();
    urlBodyData.append('session', loginData.sessionId);
    urlBodyData.append('email', loginData.email.toLowerCase());
    urlBodyData.append('page', isWithEmail || !loginData.password ? 'email' : 'password');
    urlBodyData.append('api', 'true');
    if (loginData.password)
        urlBodyData.append('password', loginData.password);
    const path = `login/${loginData.sessionId}`;
    return await authRequest({ path, body: urlBodyData.toString(), method: 'POST' });
}

export async function getChallengeQuestion(resetPasswordUrl) {
    const path = `resetPassword/${resetPasswordUrl}`;
    return await authRequest({ path, method: 'GET' });
}

export const authRequest = async ({ path, method, body }) => {
    const clientData = getAppConfig();

    const response = await fetch(`${clientData.authUrl}/${path}`, {
        method,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded', // Set content type to form data
        },
        ...method === 'POST' ? { body } : {},
        credentials: 'include'
    });
    if (response.status !== 500) {
        const result = await response.json();
        return result;
    } else {
        throw 'Something went wrong.';
    }
};

export function emailClicked(nonce, email) {
    return (dispatch, getState) => {
        const { apiUrl, corsOriginUrl } = getAppConfig();

        return reqwest({
            method: 'post',
            url: `${apiUrl}/emailClicked`,
            crossOrigin: true,
            contentType: 'application/json',
            data: JSON.stringify({ nonce, email }),
            headers: {
                'Access-Control-Allow-Origin': corsOriginUrl
            }
        }).then(response => {
            // registration flow updated - email successfully clicked
        }).catch(err => {
            // failed update registration flow
        });
    };
}

export function passwordHasBeenSet() {
    return (dispatch, getState) => {
        const query = toQuery(node('me', [
            'sub',
            'email',
            node('institution', [
                'id',
                'name',
            ]),
            'hasCompletedRegistration',
            node('currentTaskStep', [
                node('task', [
                    'id',
                ]),
                node('step', [
                    'id',
                    node('state', [
                        'id',
                        'name',
                        'displayName',
                        node('action', [
                            'id',
                            'name',
                            'type'
                        ])
                    ])
                ])
            ])
        ]));

        return queryGraphQL(query).then(response => {
            const actionId = lodash.get(response, 'data.me.currentTaskStep.step.state.action.id', null);
            if (!actionId) {
                return;
            }
            const actionName = lodash.get(response, 'data.me.currentTaskStep.step.state.action.name', null);
            if (actionName !== 'Set Password') {
                return;
            }
            const taskId = lodash.get(response, 'data.me.currentTaskStep.task.id', null);
            if (!taskId) {
                return;
            }

            const mutation = `
                mutation {
                  completeTaskAction(input: { taskId: "${taskId}", actionId: "${actionId}"} ) {
                    task {
                      id
                    }
                  }
                }
            `;

            return queryGraphQL(mutation);
        });
    };
}

export function registerUser(nonce, email) {
    return (dispatch, getState) => {
        dispatch(emailClicked(nonce, email));
        dispatch(loginStart());

        const registrationUrl = lodash.get(getState(), 'application.config.registrationUrl', null);
        if (lodash.isNil(registrationUrl)) {
            return dispatch(loginError('Application Configuration not found'));
        }

        return authenticate(`${registrationUrl}?nonce=${encodeURIComponent(nonce)}&email=${encodeURIComponent(email)}`)
            .then(auth => dispatch(loginComplete(auth)))
            .catch(({ errors }) => dispatch(loginError(errors)))
            .then(() => dispatch(getMeStart()))
            .then(() => dispatch(passwordHasBeenSet()))
            .then(() => getMeQuery())
            .then(me => dispatch(getMeComplete(me)))
            .catch(({ errors }) => dispatch(getMeError(errors)));
    };
}

export function updateMe(meAttributes) {
    return {
        type: UPDATE_ME,
        payload: meAttributes
    };
}

export function removeMe() {
    return dispatch => {
        dispatch(addApplicationMessage('info', 'You have been logged out'));
        dispatch({
            type: REMOVE_ME
        });
    };
}

export function setReloading(value) {
    return {
        type: SET_RELOADING,
        payload: !!value
    };
}
